import { Box, Typography } from '@mui/material';
import logo from '../../../assets/logo/logo 3.png';
import background from '../../../assets/defaultImages/building_2.png';
import './ValidatedIdentity.scss';
import { useTranslation } from 'react-i18next';

const ValidatedIdentity = () => {
    const { t } = useTranslation();

    return (
        <Box
            className='validated-identity-content'
            sx={{
                position: 'relative',
                width: '100%',
                height: '100vh',
                backgroundImage: `url(${background})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    bgcolor: 'white',
                    p: 4,
                    width: 600,
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    borderRadius: 2,
                    zIndex: 1,
                    margin: '30px',
                }}
            >
                <img src={logo} alt='Identity Validated' />
                <h2 style={{ marginTop: '20px' }}>{t('identity_validated')}</h2>
                <Typography variant='body1' component='body1' gutterBottom>
                    {t('no_need_to_revalidate')}
                </Typography>
            </Box>
        </Box>
    );
};

export default ValidatedIdentity;
